/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelCustomerRoutingGuide.ts          *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const AutogenUserSavedSearchEndpoint = "lme/ar/customer-routing-guide";

export class AutogenModelCustomerRoutingGuide<RowType extends ModelRow> extends Endpoint<RowType, RowCustomerRoutingGuideFields> {
    constructor(ctor: RowConstructor) {
        super(AutogenUserSavedSearchEndpoint, ctor);
    }
}

export class AutogenRowCustomerRoutingGuide extends ModelRow<RowCustomerRoutingGuideFields> {
    constructor(values?: Partial<RowCustomerRoutingGuideFields>) {
        super(AutogenUserSavedSearchEndpoint, true, values);
    }
}

export interface RowCustomerRoutingGuideFields {
    company_id: string;
    customer_id: string;
    descr: string;
    id: string;
    routing_guide: string;
    sequence: number;
}

